/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RetrySettings
 */
export class RetrySettings {
    /**
     *
     * @type {string}
     * @memberof RetrySettings
     */
    _id?: string;
    /**
     *
     * @type {number}
     * @memberof RetrySettings
     */
    discountAmount: number;
    /**
     *
     * @type {number}
     * @memberof RetrySettings
     */
    expirationTime: number;
    /**
     *
     * @type {number}
     * @memberof RetrySettings
     */
    totalRetries: number;
    /**
     *
     * @type {boolean}
     * @memberof RetrySettings
     */
    active: boolean;
    /**
     *
     * @type {string}
     * @memberof RetrySettings
     */
    discountSourcePrice: RetrySettingsDiscountSourcePriceEnum;
    /**
     *
     * @type {string}
     * @memberof RetrySettings
     */
    symbol: RetrySettingsSymbolEnum;
    /**
     *
     * @type {string}
     * @memberof RetrySettings
     */
    discountSettings: RetrySettingsDiscountSettingsEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum RetrySettingsDiscountSourcePriceEnum {
    OriginalPrice = 'Original Price',
    PaidPrice = 'Paid Price',
}
/**
 * @export
 * @enum {string}
 */
export enum RetrySettingsSymbolEnum {
    Usd = 'USD',
    Percent = 'PERCENT',
}
/**
 * @export
 * @enum {string}
 */
export enum RetrySettingsDiscountSettingsEnum {
    Custom = 'Custom',
}
